/* eslint-disable */
import React from 'react';
import { AiFillStar  }  from 'react-icons/ai';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';


const Chef = () => {


return (
  <div className="app__bg app__wrapper section__padding" id="chef">
   
    <div className="app__wrapper_info">
      <SubHeading style={{textAlign:"center"}} title="Volcano Oasis" />
      <h1 className="headtext__cormorant" style={{textAlign:"center"}}> Avis:</h1>

      <div className="app__chef-content">
    

          
          <div class="cards">
    <div class="card card-1">
      <div class="card__icon"><i class="fas fa-bolt"></i></div>
      <p class="card__exit"><i class="fas fa-times"></i></p>
      <p class="card__title">      <img src={images.quote} alt="quote_image" />La petite claque ! Viande bien cuite, pas grasse ça fesait longtemps ! Je recommande le volcano ! Un choix très long peu être un peu trop.
</p>
<br/>
      <h3 class="card__apply">
        <a class="card__link" href="#">Jerome<i class="fas fa-arrow-right"></i></a>
      </h3>
      <AiFillStar color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar   color='orange' />
      <AiFillStar   style={{ stroke: "orange", strokeWidth: "50"}}  />
    </div>
    <div class="card card-1">
      <div class="card__icon"><i class="fas fa-bolt"></i></div>
      <p class="card__exit"><i class="fas fa-times"></i></p>
      <p class="card__title">      <img src={images.quote} alt="quote_image" />L'un des meilleurs kebab du mans ! Le proprios est très gentil et amical .
</p>
<br/>
      <h3 class="card__apply">
        <a class="card__link" href="#">Moataz Cherkaoui<i class="fas fa-arrow-right"></i></a>
      </h3>
      <AiFillStar color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar   color='orange' />
      <AiFillStar   color='orange' />
    
    </div>
    <div class="card card-1">
      <div class="card__icon"><i class="fas fa-bolt"></i></div>
      <p class="card__exit"><i class="fas fa-times"></i></p>
      <p class="card__title">      <img src={images.quote} alt="quote_image" />Franchement 7€ Pour un kebab bien mais BIEN généreux sur les portions. C’est rare pour ma part donc je recommande pour les gourmands. tout les plats sont bien garnis.
</p>
<br/>
      <h3 class="card__apply">
        <a class="card__link" href="#">Mrs Siale<i class="fas fa-arrow-right"></i></a>
      </h3>
      <AiFillStar color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar   color='orange' />
      <AiFillStar   color='orange' />
    </div>
    <div class="card card-2">
      <div class="card__icon"><i class="fas fa-bolt"></i></div>
      <p class="card__exit"><i class="fas fa-times"></i></p>
      <p class="card__title"><img src={images.quote} alt="quote_image" />Le meilleur du Mans, niveau goût bravo,rien à dire... 👏🤗,je le conseille fortement.</p>
    <br/>  <h3 class="card__apply">
        <a class="card__link" href="#">Del arte positif<i class="fas fa-arrow-right"></i></a>
      </h3>
      <AiFillStar color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar   color='orange' />
      <AiFillStar   color='orange' />
    </div>
    <div class="card card-3">
      <div class="card__icon"><i class="fas fa-bolt"></i></div>
      <p class="card__exit"><i class="fas fa-times"></i></p>
      <p class="card__title"><img src={images.quote} alt="quote_image" />Très bon service, des menus assez variés, à des prix abordables. Je vous le conseille. </p>
     <br /> <h3 class="card__apply">
        <a class="card__link" href="#">Christian KPEDZROKU <i class="fas fa-arrow-right"></i></a>
      </h3>
      <AiFillStar color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar   color='orange' />
      <AiFillStar   color='orange' />
    </div>
    <div class="card card-4">
      <div class="card__icon"><i class="fas fa-bolt"></i></div>
      <p class="card__exit"><i class="fas fa-times"></i></p>
      <p class="card__title"><img src={images.quote} alt="quote_image" />Gérant super gentil ! plats très copieux</p>
      
      <br />
      <div className='flexbox'>
      <div>
        <h3 class="card__apply">

        <a class="card__link" href="#">Aude Piedalu <i class="fas fa-arrow-right"></i></a>
     
        </h3>
        <AiFillStar color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar  color='orange' />
      <AiFillStar   color='orange' />
      <AiFillStar   color='orange' />
        
        </div>
        <div>
       
</div>

      </div>
      
      
    </div>
    
    
        
       </div>
       
      </div>
      <div className="app__chef-sign">
        <p>Les avis sont des avis google des clients qui ont visités le restaurant.</p>
        <p className="p__opensans">Hitana Hamadi</p>
     
      </div>
    </div>
  </div>
)};

export default Chef;
